import UploadFile from './uploadFile.vue'
export default UploadFile
